import { OpeningKind } from 'shared-types';
import { TranslationService } from '../translation/TranslationService';

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Compute the name an opening annotation should carry after a kind change
 * (Door ↔ Window). Shared by `OpeningAnnotation` (floorplan OPENING) and
 * `PointoramaOpeningSketch` (wall-sketch OPENING_SKETCH).
 *
 * Only names that ARE a kind default — the English literals or the current
 * language's translation of 'Door'/'Window', optionally followed by a
 * whitespace suffix like " 2" — are rewritten. Anything else is a custom or
 * foreign-language name the user owns, so it is returned unchanged (PK-1063:
 * the old unconditional rewrite forced every opening back to English on load).
 */
export function openingNameForKind(currentName: string, kind: OpeningKind, translationService: TranslationService): string {
  const target = kind === OpeningKind.WINDOW ? translationService.t('Window') : translationService.t('Door');
  if (!currentName) return target;
  const defaults = new Set(['Door', 'Window', translationService.t('Door'), translationService.t('Window')]);
  const pattern = new RegExp(`^(?:${[...defaults].map(escapeRegExp).join('|')})(\\s.*)?$`, 'i');
  const match = currentName.match(pattern);
  return match ? target + (match[1] ?? '') : currentName;
}
